/* app/fonts/ichannel.fonts.scss */
@font-face {
  font-family: "ichannel-iconfont";
  src: url("./media/ichannel-iconfont.eot");
  src:
    url("./media/ichannel-iconfont.eot?#iefix") format("embedded-opentype"),
    url("./media/ichannel-iconfont.woff") format("woff"),
    url("./media/ichannel-iconfont.ttf") format("truetype"),
    url("./media/ichannel-iconfont.svg#ichannel-iconfont") format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "ichannel-iconfont" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
[class^=icon-]:before,
[class*=" icon-"]:before {
  font-family: "ichannel-iconfont" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-ads:before {
  content: "a";
}
.icon-ads-capsul:before {
  content: "b";
}
.icon-arrow-down:before {
  content: "c";
}
.icon-arrow-left:before {
  content: "d";
}
.icon-arrow-right:before {
  content: "e";
}
.icon-back:before {
  content: "f";
}
.icon-close-pop:before {
  content: "g";
}
.icon-craete-graphic:before {
  content: "h";
}
.icon-dropdown-v:before {
  content: "i";
}
.icon-filter-menu-more:before {
  content: "j";
}
.icon-next:before {
  content: "k";
}
.icon-minus-icon:before {
  content: "l";
}
.icon-load-v-big:before {
  content: "m";
}
.icon-load-fail-thum:before {
  content: "n";
}
.icon-load-fail-big:before {
  content: "o";
}
.icon-live:before {
  content: "p";
}
.icon-layer-ad:before {
  content: "q";
}
.icon-graphics-capsul:before {
  content: "r";
}
.icon-layer-graphics:before {
  content: "s";
}
.icon-graphics:before {
  content: "t";
}
.icon-filter-sort-icon:before {
  content: "u";
}
.icon-filter-menu-top-arrow:before {
  content: "v";
}
.icon-thum-hamburger:before {
  content: "w";
}
.icon-thum-info:before {
  content: "x";
}
.icon-thum-load-v:before {
  content: "y";
}
.icon-thum-play:before {
  content: "z";
}
.icon-thum-preset:before {
  content: "A";
}
.icon-thum-preview:before {
  content: "B";
}
.icon-plus-icon:before {
  content: "C";
}
.icon-pop-trash:before {
  content: "D";
}
.icon-top-pannel-user-arrow:before {
  content: "E";
}
.icon-upload-video:before {
  content: "F";
}
.icon-thum-drag:before {
  content: "G";
}
/*# sourceMappingURL=ichannel.fonts.css.map */
